module.exports = __webpack_public_path__ + "produce-fresh-grass-10.jpg?d1809688e6b5019b614a3dedcebc8075";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-10.jpg
// module id = 47
// module chunks = 0